import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {Box, Chip, CircularProgress} from "@mui/material";
import {BarChart} from "@mui/x-charts";
import {useEffect, useState} from "react";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";

const Dashboard = () => {
  // eslint-disable-next-line
  const {data, list, loading} = useApiRequest({baseUrl: "/users", resource: "users"});
  const [formattedData, setFormatedData] = useState([]);
  const [healthStatus, setHealthStatus] = useState("checking");

  useEffect(() => {
    (async () => {
      try {
        await list();
        checkHealth();
      } catch (error) {
        console.error("Error al cargar los usuarios:", error);
      }
    })();

    const interval = setInterval(() => {
      checkHealth();
    }, 60000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  const checkHealth = async () => {
    const apiUrl = process.env.REACT_APP_API_AUTH;
    try {
      const response = await fetch(`${apiUrl}/healthz`);
      if (response.ok) {
        setHealthStatus("online");
      } else {
        setHealthStatus("offline");
      }
    } catch (error) {
      setHealthStatus("offline");
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      const chartData = data.reduce((acc, item) => {
        const date = new Date(item.created_at).toLocaleDateString();
        if (!acc[date]) {
          acc[date] = {created_at: date, count: 0};
        }
        acc[date].count += 1;
        return acc;
      }, {});

      const formattedData = Object.values(chartData).map(({created_at, count}) => ({
        x: created_at,
        y: count
      }));

      setFormatedData(formattedData);
    }
    // eslint-disable-next-line

    // eslint-disable-next-line
  }, [data]);

  return (
    <Window title={"Dashboard"}>
      <Box sx={{display: "flex", justifyContent: "flex-end", mb: 2}}>
        <Chip
          icon={<FiberManualRecordIcon />}
          label={
            healthStatus === "online"
              ? "API Auth Online"
              : healthStatus === "offline"
                ? "API Auth Offline"
                : "Checking..."
          }
          color={healthStatus === "online" ? "success" : healthStatus === "offline" ? "error" : "default"}
          size="small"
        />
      </Box>
      {loading && <CircularProgress />}
      {!loading && (
        <>
          <BarChart
            key={1}
            xAxis={[
              {
                dataKey: "x",
                scaleType: "band"
              }
            ]}
            series={[{dataKey: "y"}]}
            width={800}
            height={500}
            barLabel="value"
            dataset={formattedData}
          />
          <div
            style={{
              marginTop: "20px",
              fontSize: "16px",
              fontWeight: "bold",
              color: "white"
            }}
          >
            Total de usuarios: {data?.length}
          </div>
        </>
      )}
    </Window>
  );
};

export default Dashboard;
